import MpDownloadAppModal from '@/common/components/mpDownloadAppModal/index.vue';
import env from '@/common/util/env';

let $container = null;
let modalInstance = null;

/**
 * 提示用户下载 APP 弹窗
 * @param Vue
 * @param params
 * @param { string } params.name
 * @param { string } params.link
 */
const showDownloadAppModal = (Vue, params = {}) => {
    const ModalController = Vue.extend(MpDownloadAppModal);
    if (!$container) {
        $container = document.createElement('div');
        document.body.appendChild($container);
    }
    if (!modalInstance) {
        modalInstance = new ModalController({ propsData: { name: params.name, link: params.link } });
        modalInstance.$on('on-hide', () => {
            $container.removeChild(modalInstance.$el);
            modalInstance.$destroy();
            modalInstance = null;
        });
    }
    modalInstance.$mount();
    $container.appendChild(modalInstance.$el);
};

const createTransparentModal = $el => {
    $el.style.position = 'relative';
    const $modal = document.createElement('div');
    $modal.style.position = 'absolute';
    $modal.style.top = '0';
    $modal.style.left = '0';
    $modal.style.right = '0';
    $modal.style.bottom = '0';
    $modal.style.zIndex = '1000';
    $el.appendChild($modal);
};

const MpDownloadAppDirective = {
    install(Vue) {
        Vue.directive('mini-program-click', {
            bind(el, binding) {
                if (env.isCommunityMiniProgram) {
                    return;
                }
                if (!env.isWechatMiniProgram || (binding.value && binding.value.ignore)) {
                    return;
                }

                el.addEventListener(
                    'click',
                    e => {
                        e.preventDefault();
                        e.stopPropagation();

                        showDownloadAppModal(Vue, binding.value);
                    },
                    true
                );

                if (binding.value && binding.value.useTransparentModal) {
                    createTransparentModal(el);
                }
            },
        });
    },
};

export default MpDownloadAppDirective;
